import React, { useState } from "react";
import FoodCard from "./FoodCard";
import "../../../styles.css";
import foodData from "./foodData";

import { AnimatePresence, motion } from "framer-motion";

export default function FoodList() {
  const [filter, setFilter] = useState("All");
  const [carbFilter, setCarbFilter] = useState("All"); // Secondary carb filter

  const filteredFoods =
    filter === "All"
      ? foodData
      : foodData.filter((food) => food.macronutrient.includes(filter));

  const carbFilteredFoods =
    carbFilter === "All"
      ? filteredFoods
      : filteredFoods.filter((food) => food.carbType === carbFilter);

  return (
    <>
      {/* Filter Buttons */}
      <div className="filter-buttons-container">
        {[
          { label: "All", icon: "🌍" },
          { label: "Protéines", icon: "🥩" },
          { label: "Lipides", icon: "🥑" },
          { label: "Glucides", icon: "🍞" },
        ].map(({ label, icon }) => (
          <button
            key={label}
            className={`filter-button ${
              filter === label ? "active" : "inactive"
            }`}
            onClick={() => {
              setFilter(label);
              setCarbFilter("All"); // Reset carb filter when switching filters
            }}
          >
            <span style={{ marginRight: "8px", fontSize: "20px" }}>{icon}</span>
            {label}
          </button>
        ))}
      </div>

      {/* Secondary Carb Filter (Only visible when Glucides is selected) */}
      {filter === "Glucides" && (
        <div className="secondary-filter-buttons-container">
          {[
            { label: "All", icon: "🌍" },
            { label: "Simple", icon: "🍬" },
            { label: "Complex", icon: "🥔" },
          ].map(({ label, icon }) => (
            <button
              key={label}
              className={`secondary-filter-button ${
                carbFilter === label ? "active-secondary" : "inactive-secondary"
              }`}
              onClick={() => setCarbFilter(label)}
            >
              <span style={{ marginRight: "8px", fontSize: "20px" }}>
                {icon}
              </span>
              {label}
            </button>
          ))}
        </div>
      )}

      {/* Food Cards with Animations */}
      <div className="food-list">
        {carbFilteredFoods.map((food) => (
          <FoodCard
            key={food.name}
            name={food.name}
            image={food.image}
            description={food.description}
            macronutrient={food.macronutrient}
          />
        ))}
      </div>
    </>
  );
}
